import { buttonSkinData } from 'baseline-ui/button';

const radioButtonGroupSkinData = buttonSkinData;

export default radioButtonGroupSkinData;
